import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Conditional } from '@codametrix/ui-components';
import { createPortal } from 'react-dom';
import { LoadingSlugs } from '@codametrix/ui-components';
import './coder-notes.scss';
import { Avatar } from '@chakra-ui/react';
import * as userUtils from '../../core/utils/user-utils';
import { Textarea } from '../../components/textarea/textarea';
import { codeBenchActions } from '@codametrix/ui-common';
import { objectUtils } from '@codametrix/ui-common';
import { CoderNoteCard } from './coder-note-card';
import { toggleDrawer } from '../../actions/ui';
const fallbackElement = document.createElement('div');
const CoderNotes = ()=>{
    const { isOpen, servicesLoading, coderNotesParams, coderNotesList, activeUser, coderNote } = useSelector((state)=>{
        return state.coderNotes;
    });
    const dispatch = useDispatch();
    const [coderNoteContent, setCoderNoteContent] = useState('');
    const [editMode, setEditMode] = useState({
        noteId: '',
        isEditEnabled: false
    });
    const textareaRef = useRef(null);
    useEffect(()=>{
        setCoderNoteContent(coderNote);
    }, [
        coderNote
    ]);
    useEffect(()=>{
        setCoderNoteContent('');
        toggleEditMode(false);
    }, [
        isOpen
    ]);
    /** Focus and active cursor on text area by default
   * and also when edit mode is disabled on note */ useEffect(()=>{
        if (!editMode?.isEditEnabled) {
            textareaRef.current?.focus();
        }
    }, [
        editMode
    ]);
    /** Handler for change in add note content */ const handleCoderNoteChange = (e)=>{
        e.preventDefault();
        let inputValue = e.target.value;
        setCoderNoteContent(inputValue);
    };
    /** Handler for cancel on Add Note,
   *  should close the drawer and reset the component state */ const handleCoderNoteCancel = (e)=>{
        e.preventDefault();
        dispatch(toggleDrawer(false));
        setCoderNoteContent('');
    };
    /** Handler for add coder notes*/ const handleAddCoderNotes = (e)=>{
        e.preventDefault();
        if (!objectUtils.isEmpty(coderNoteContent)) {
            dispatch(codeBenchActions.addCoderNote({
                ...coderNotesParams,
                noteContent: coderNoteContent
            }));
        }
    };
    /** Handler to save edited note */ const handleEditCoderNotes = (note)=>{
        dispatch(codeBenchActions.updateCoderNote({
            ...coderNotesParams,
            noteId: note.note_id,
            noteContent: note.note_content
        }));
        toggleEditMode(false);
    };
    /** Handler to delete coder note*/ const handleDeleteCoderNotes = (note)=>{
        dispatch(codeBenchActions.deleteCoderNote({
            ...coderNotesParams,
            noteId: note.note_id
        }));
    };
    /** toggle edit mode of note and ensure only one note is enabled to edit at a time */ const toggleEditMode = (toggle, noteId)=>{
        setEditMode({
            noteId: noteId ?? '',
            isEditEnabled: toggle
        });
    };
    /** Click on ESC should close the drawer */ const handleKeyDown = (event)=>{
        if (event.key === 'Escape') {
            if (!editMode?.isEditEnabled) dispatch(toggleDrawer(false));
        }
    };
    const userAvatarInitials = userUtils.getAvatarInitials(activeUser.firstName, activeUser.lastName);
    const userAvatar = /* @ts-ignore */ /*#__PURE__*/ _jsx(Avatar, {
        name: userAvatarInitials,
        bgColor: "#6B8D99",
        color: "#FFFFFF",
        size: "sm"
    });
    return /*#__PURE__*/ _jsx("div", {
        onKeyDown: handleKeyDown,
        children: /*#__PURE__*/ _jsx(Conditional, {
            on: isOpen,
            children: servicesLoading ? /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ createPortal(/*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            /*#__PURE__*/ _jsx(LoadingSlugs, {
                                width: "25",
                                numberItems: 1
                            }, "loading-slugs"),
                            /*#__PURE__*/ _jsx(LoadingSlugs, {
                                width: "25",
                                numberItems: 1
                            }, "loading-slugs"),
                            /*#__PURE__*/ _jsx(LoadingSlugs, {
                                width: "80",
                                numberItems: 1
                            }, "loading-slugs")
                        ]
                    }), document.getElementById('cmx-drawer-header') || fallbackElement),
                    /*#__PURE__*/ createPortal(/*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            /*#__PURE__*/ _jsx(LoadingSlugs, {
                                numberItems: 3
                            }, "loading-slugs"),
                            /*#__PURE__*/ _jsx("br", {}),
                            /*#__PURE__*/ _jsx(LoadingSlugs, {
                                width: "60",
                                numberItems: 5
                            }, "loading-slugs"),
                            /*#__PURE__*/ _jsx("br", {}),
                            /*#__PURE__*/ _jsx(LoadingSlugs, {
                                width: "60",
                                numberItems: 5
                            }, "loading-slugs"),
                            /*#__PURE__*/ _jsx("br", {}),
                            /*#__PURE__*/ _jsx(LoadingSlugs, {
                                width: "60",
                                numberItems: 5
                            }, "loading-slugs")
                        ]
                    }), document.getElementById('cmx-drawer-body') || fallbackElement)
                ]
            }) : /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx(Conditional, {
                        on: !!document.getElementById('cmx-drawer-header'),
                        children: /*#__PURE__*/ _jsx(_Fragment, {
                            children: /*#__PURE__*/ createPortal(/*#__PURE__*/ _jsxs(_Fragment, {
                                children: [
                                    "Notes for ",
                                    coderNotesParams?.titleName,
                                    " #",
                                    coderNotesParams?.titleText
                                ]
                            }), document.getElementById('cmx-drawer-header') || fallbackElement)
                        })
                    }),
                    /*#__PURE__*/ _jsx(Conditional, {
                        on: !!document.getElementById('cmx-drawer-body'),
                        children: /*#__PURE__*/ _jsx(_Fragment, {
                            children: /*#__PURE__*/ createPortal(/*#__PURE__*/ _jsx(_Fragment, {
                                children: coderNotesList?.map((entry, entryIndex)=>{
                                    return /*#__PURE__*/ _jsx(CoderNoteCard, {
                                        note: entry,
                                        activeUser: activeUser,
                                        editMode: editMode,
                                        toggleEditMode: toggleEditMode,
                                        handleEditCoderNotes: handleEditCoderNotes,
                                        handleDeleteCoderNotes: handleDeleteCoderNotes
                                    });
                                })
                            }), document.getElementById('cmx-drawer-body') || fallbackElement)
                        })
                    }),
                    /*#__PURE__*/ _jsx(Conditional, {
                        on: !!document.getElementById('cmx-drawer-footer'),
                        children: /*#__PURE__*/ _jsx(_Fragment, {
                            children: /*#__PURE__*/ createPortal(/*#__PURE__*/ _jsxs("div", {
                                className: "coder-notes-send",
                                children: [
                                    /*#__PURE__*/ _jsx(Textarea, {
                                        leftIcon: userAvatar,
                                        placeholder: "Add Note",
                                        value: coderNoteContent,
                                        disabled: editMode.isEditEnabled,
                                        onChange: handleCoderNoteChange,
                                        ref: textareaRef
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "coder-note-actions",
                                        children: [
                                            /*#__PURE__*/ _jsx("button", {
                                                onClick: (ev)=>{
                                                    handleCoderNoteCancel(ev);
                                                },
                                                className: `chakra-secondary-button ${editMode.isEditEnabled ? 'disabled' : ''}`,
                                                children: "Cancel"
                                            }),
                                            /*#__PURE__*/ _jsx("button", {
                                                onClick: (ev)=>handleAddCoderNotes(ev),
                                                className: `chakra-primary-button ${editMode.isEditEnabled || objectUtils.isEmpty(coderNoteContent) ? 'disabled' : ''}`,
                                                children: "Save"
                                            })
                                        ]
                                    })
                                ]
                            }), document.getElementById('cmx-drawer-footer') || fallbackElement)
                        })
                    })
                ]
            })
        })
    });
};
CoderNotes.displayName = 'CoderNotes';
export { CoderNotes };
